module.exports = __webpack_public_path__ + "static/media/stopwatch.d9325285.svg";